export function sanitizeRedirectPath(redirectPath: string | null | undefined): string {
  if (!redirectPath) {
    return '/';
  }

  if (!redirectPath.startsWith('/') || redirectPath.startsWith('//')) {
    return '/';
  }

  try {
    const decodedPath = decodeURIComponent(redirectPath);

    if (!decodedPath.startsWith('/') || decodedPath.startsWith('//')) {
      return '/';
    }

    if (/^[a-zA-Z][a-zA-Z\d+.-]*:/.test(decodedPath)) {
      return '/';
    }

    return decodedPath;
  } catch {
    return '/';
  }
}